import React from 'react'
import {
  Dialog,
  Typography,
  Box,
  styled,
  Button,
  DialogContent,
  DialogActions,
  DialogTitle,
  IconButton,
  Divider,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

type ConfirmationDialogProps = {
  open: boolean
  type: 'Create' | 'Update' | string
  onCancel: () => void
  onConfirm: () => void
}

const ActionButton = styled(Button)<{ bgcolor: string }>(({ bgcolor }) => ({
  backgroundColor: bgcolor,
  color: 'white',
  padding: '4px 16px',
  fontSize: '0.8125rem',
  textTransform: 'none',
}))

const ButtonGroup = styled(DialogActions)({
  display: 'flex',
  justifyContent: 'center',
  gap: 8,
  paddingBottom: 16,
})

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  type,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          minWidth: 300,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontSize="1rem" fontWeight={500} color="#505470">
            Confirm Exit
          </Typography>
          <IconButton
            size="small"
            onClick={onCancel}
            sx={{ width: 20, height: 20 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Divider sx={{ mt: 1 }} />
      </DialogTitle>

      <DialogContent sx={{ px: 3, pt: 2, pb: 0 }}>
        <Typography
          fontSize="0.9rem"
          textAlign="center"
          color="text.primary"
          sx={{ mb: 2 }}
        >
          Are you sure you want to exit{' '}
          {type === 'Create' ? 'filing' : 'updating'} a ticket?
        </Typography>
      </DialogContent>

      <ButtonGroup>
        <ActionButton bgcolor="#fe2e2c" onClick={onCancel}>
          No
        </ActionButton>
        <ActionButton bgcolor="#379F86" onClick={onConfirm}>
          Yes
        </ActionButton>
      </ButtonGroup>
    </Dialog>
  )
}
